const FIELD_NAME_MAP = {
    'customer.clientname': 'clientName',
    'customer.companyname': 'companyName',
    'customer.identitynumber': 'tcid',
    'customer.taxnumber': 'taxNumber',
    'customer.crsnumber': 'crsNumber',
    'customer.address': 'address',
    'customer.district': 'district',
    'customer.phones.phone': 'phoneNumber',
    'customer.emails.email': 'email',
    'customer.ibans.iban': 'iban',
    'customer.agent': 'agentId',
    'licenseplate.licenseplatenumber': 'licensePlate',
    'licenseplate.carchassisnumber': 'chassisNumber',
    'licenseplate.carbrand': 'carBrand',
    'licenseplate.carmodel': 'carModel',
    'licenseplate.caryear': 'carYear',
    'licenseplate.trafficinsurancepolicy.trafficinsuranceprovider': 'trafficInsurancePolicy.trafficInsuranceProvider',
    'licenseplate.cascoinsurancepolicy.cascoinsuranceprovider': 'cascoInsurancePolicy.cascoInsuranceProvider',
    'accident.accidentdate': 'accidentDate',
    'accident.estimateddepreciationamount': 'estimatedDepreciationAmount',
    'accident.damageamount': 'damageAmount',
    'accident.counterpartytype': 'counterpartyType',
    'accident.counterpartyidentificationnumber': 'counterpartyIdentificationNumber',
    'accident.counterpartytaxnumber': 'counterpartyTaxNumber',
    'accident.counterpartycarowner': 'counterpartyCarOwner',
    'accident.counterpartylicenseplatenumber': 'counterpartyLicensePlateNumber',
    'accident.counterpartytrafficinsurancepolicy.trafficinsuranceprovider': 'counterpartyTrafficInsurancePolicy.trafficInsuranceProvider',
    'accident.counterpartycascoinsurancepolicy.cascoinsuranceprovider': 'counterpartyCascoInsurancePolicy.cascoInsuranceProvider',
    'accident.ourfaultrate': 'ourFaultRate',
    'accident.counterpartyfaultrate': 'counterpartyFaultRate',
    'accident.appointedexperts': 'appointedExperts',
    'powerofattorney.poanumber': 'powerOfAttorneyNumber',
    'powerofattorney.poadate': 'powerOfAttorneyDate',
    'powerofattorney.notaryofpoa': 'notaryNumber',
    'powerofattorney.contractrate': 'contractRate',
    'accidentfile.fileopendate': 'registrationDate',
    'accidentfile.jobtobeworked': 'jobToBeWorked',
    'accidentfile.whoseinsurance': 'whoseInsurance',
    'accidentfile.documentrequestdate': 'documentRequestDate',
    'accidentfile.documentrequeststatus': 'documentRequestStatus',
    'accidentfile.documentreceiveddate': 'documentReceivedDate',
};

const resolveValueByPath = (source, path) => {
    const keys = path.split('.');
    let value = source;
    let isValid = true;

    for (const key of keys) {
        if (value === null || value === undefined) {
            isValid = false;
            break;
        }

        if (!Object.prototype.hasOwnProperty.call(value, key) || value[key] === undefined || value[key] === null) {
            if (key !== keys[keys.length - 1]) {
                isValid = false;
                break;
            }
            value = value[key];
        } else {
            value = value[key];
        }
    }

    return { value, isValid };
};

export const validateRequiredFieldsByPermissions = ({ fieldPermissions, formData }) => {
    const errors = {};

    fieldPermissions.forEach((permission) => {
        if (!permission.required) {
            return;
        }

        const { value, isValid } = resolveValueByPath(formData, permission.fieldName);
        const isEmpty = value === '' || value === null || value === undefined || (Array.isArray(value) && value.length === 0);

        if (!isValid || isEmpty) {
            const mappedField = FIELD_NAME_MAP[permission.fieldName] || permission.fieldName;
            errors[mappedField] = 'Bu alan zorunludur.';
        }
    });

    return errors;
};
